import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { toDto as companyToDto } from '../../../models/adapters/CompanyAdapter';
import { toDto as placeUserToDto } from '../../../models/adapters/PlaceUserAdapter';
import { registerCompany, RegisterCompanyActionType, registrationCompleted, registrationFailed } from '../../actions/registration/registerCompany';
import getPublicResponse from '../getPublicResponse';

function* registerCompanySaga({ payload }: RegisterCompanyActionType) {
  const timestamp = moment();
  const { companyRegistrationData } = payload;
  const { company, placeUser, newPassword, uuid } = companyRegistrationData;
  const companyDto = companyToDto(company);
  const placeUserDto = placeUserToDto(placeUser);
  const response = yield getPublicResponse(PublicServerPlaceEvent.companyRegistration, {
    company: companyDto,
    placeUser: placeUserDto,
    password: newPassword,
  });
  if (response.error) {
    const action = registrationFailed({ uuid, timestamp });
    yield put(action);
  } else {
    const action = registrationCompleted({ uuid, timestamp });
    yield put(action);
  }
}

export default function* watchRegisterCompanySaga() {
  yield takeEvery(registerCompany, registerCompanySaga);
}
